import { useMutation, useQueryClient } from '@tanstack/react-query';
import { buildPartnerCommunityCreatePayload } from '../components/Partner/Community/communityEditConstants';
import { createPartnerGroupChannel } from '../services/partnerGroupChannel';
import { partnerQueryKeys } from './query-keys';

export const useCreatePartnerCommunityMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ partnerId, form }) => {
      const result = await createPartnerGroupChannel(
        buildPartnerCommunityCreatePayload(partnerId, form),
      );
      if (!result.success) {
        throw new Error(result.message || 'Failed to create community');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
